module.exports = __webpack_public_path__ + "img/10.3e879720.png";